import { createFileRoute } from "@tanstack/react-router";
import { EditNumber } from "../../pages/Auth/EditNumber";
import { requireAuth } from "../../utils/routeGuards";

export const Route = createFileRoute("/auth/edit-number")({
  beforeLoad: ({ location }) => requireAuth(location),
  component: EditNumber,
});
